<template>
  <div>
    <b-row class="mt-0 mx-1 pt-0 d-flex justify-content-center">
      <b-col cols="12" lg="8" md="9" sm="9" xl="9">
        <b-row class="text-left d-flex justify-content-center">
          <b-col class="my-2 p-0" cols="12" lg="3" md="3" sm="3" xl="3">
            <multiselect
              v-if="levelOneList"
              id="wisdom"
              v-model="knowledgeValue"
              :close-on-select="true"
              :options="levelOneList"
              label="name"
              track-by="knowledge_level1_id"
              :searchable="true"
              :show-labels="false"
              class="multiselect-style2 custom-multiselect"
              placeholder="ทุกภูมิปัญญา"
            ></multiselect>
          </b-col>
          <b-col class="my-2 p-0" cols="12" lg="3" md="3" sm="3" xl="3">
            <multiselect
              v-if="categoriesList"
              id="type"
              v-model="categoriesValue"
              :close-on-select="true"
              :options="categoriesList"
              label="name"
              track-by="category_id"
              :searchable="true"
              :show-labels="false"
              class="multiselect-style2 custom-multiselect"
              placeholder="ทุกกลุ่มชนิดพืช"
            ></multiselect>
          </b-col>
          <b-col class="my-2 p-0" cols="12" lg="3" md="3" sm="3" xl="3">
            <multiselect
              v-if="communityList"
              id="country"
              v-model="communityValue"
              :close-on-select="true"
              :options="communityList"
              label="name"
              track-by="community_id"
              :searchable="true"
              :show-labels="false"
              class="multiselect-style2 custom-multiselect"
              placeholder="ทุกชุมชน"
            ></multiselect>
          </b-col>
          <b-col class="my-2 p-0" cols="12" lg="3" md="3" sm="3" xl="3">
            <b-form-input
              v-model="keywordValue"
              class="input_text"
              placeholder="คำค้นหา..."
              style="height: 100%"
              type="text"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="2" md="1" sm="1" xl="1">
        <div class="d-flex">
          <button class="btn-circle" @click="search">
            <b-icon class="text-white" icon="search"></b-icon>
          </button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "searchBar",
  props: {
    category: {
      default: null,
    },
    knowledge: {
      default: null,
    },
    community: {
      default: null,
    },
    keyword:{
      default: null,
    }
  },
  data() {
    return {
      keywordValue: "",
      value: "",
      knowledgeValue: null,
      communityValue: null,
      categoriesValue: null,
      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelectediuhe",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
    };
  },
  mounted() {
    this.categoriesValue = this.categoriesList.find(
      (x) => x.category_id === parseInt(this.category)
    );
    this.knowledgeValue = this.levelOneList.find(
      (x) => x.knowledge_level1_id === parseInt(this.knowledge)
    );
    this.communityValue = this.communityList.find(
      (x) => x.community_id === parseInt(this.community)
    );
    this.keywordValue = this.keyword
  },
  computed: {
    ...mapState({
      categoriesList: (state) => state.categoriesModule.categories_list,
      levelOneList: (state) => state.knowledgesModule.level_one_list,
      communityList: (state) => state.communityModule.list_community,
    }),
  },
  created() {
    this.$store.dispatch("categoriesModule/onGetCategories");
    this.$store.dispatch("knowledgesModule/onGetLevelOne");
    this.$store.dispatch("communityModule/onGetCommunityList");
  },
  components: {
    Multiselect,
  },
  methods: {
    goBack() {
      const path = `/Search`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    search() {
      let knowledge = this.knowledgeValue
        ? this.knowledgeValue.knowledge_level1_id
        : null;
      let category = this.categoriesValue
        ? this.categoriesValue.category_id
        : null;
      let community = this.communityValue
        ? this.communityValue.community_id
        : null;
      let keyword = this.keywordValue

      this.$router.push({
        name: "SearchResult",
        query: {
          knowledges_id: knowledge,
          categories_id: category,
          community_id: community,
          keyword: keyword,
        },
      });
      // const path = `/SearchResult`;
      // if (this.$route.path !== path) {
      //   this.$router.push(path);
      // }
    },
    getDetail() {
      const path = `/Detail`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
<style lang="scss"></style>
